import { useSearchParams } from "react-router-dom";
import { strings, Lang, Strings } from "./strings";

export function resolveLang(raw: string | null): Lang {
  return raw === "pt" ? "pt" : "en";
}

export function useLang(): { lang: Lang; s: Strings } {
  const [params] = useSearchParams();
  const lang = resolveLang(params.get("lang"));
  return { lang, s: strings[lang] };
}
